<ng-container>
  <header>
    <gx-button
      (click)="onCloseButtonClicked()"
      hasIcon="only"
      icon="close"
      text="{{'Close' | translate}}"
      title="{{'Close' | translate}}"
      variant="neutral"
      data-testid="detail-view-close-button" />
  </header>
  <div class="flex w-full flex-col justify-start gap-4 p-4">
    @if (headerTemplate) {
      <ng-container [ngTemplateOutlet]="headerTemplate" [ngTemplateOutletContext]="{ data: data }" />
    } @else {
      <h3 class="m-0 text-xl font-bold">{{ title }}</h3>
    }
    <ng-content></ng-content>
  </div>
</ng-container>
